import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {SearchService} from "../../services/search.service";
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
})
export class SearchComponent implements OnInit {
    public query: string = '';
    public data;

    constructor(private titleService: Title, private searchService: SearchService, private route: ActivatedRoute, private router: Router) { }

    ngOnInit()
    {
        this.titleService.setTitle('Dermabase - Zoeken');

        this.route.params.subscribe(params => {
            this.query = params['query'];
            this.titleService.setTitle('Dermabase - Zoeken: ' + this.query);

            this.searchService.search(this.query).subscribe((res) => {
                this.data = res.data;

                if(!this.data['ingredients']) {
                    if(this.data['products'].length == 1)
                    {
                        this.router.navigate(['product',this.data['products'][0]['id'],encodeURIComponent(this.data['products'][0]['Merk']+' '+this.data['products'][0]['Subnaam']).toLowerCase().replace(' ','-')], {replaceUrl: true});
                    }
                    else
                    {
                        this.router.navigate(['products',this.query], {replaceUrl: true});
                    }
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/search/search.component.ts